import { useEffect } from 'react'

import { EVENT_NAME_SCROLL } from '../../../../constants/event'
import { useResizeObserver, useThrottleFunc } from '../../../../hooks'
import { calculateElementCenterY } from '../../../../utils/common'
import { removeTableScrollEmptySpace } from '../../Table.utils'

import { TABLE_SIDE_SCROLL_PIXEL_VALUE } from './useTableSideScroll.constants'

export function useTableSideScroll({
  containerRef,
  scrollPixelValue = TABLE_SIDE_SCROLL_PIXEL_VALUE,
  scrollRef,
  tableRef,
  onChangeSideScrollButtonY,
}) {
  function calculateCenterY() {
    return calculateElementCenterY({
      container: containerRef?.current ?? scrollRef?.current,
      scrollElement: scrollRef?.current,
      onChangeY: onChangeSideScrollButtonY,
    })
  }

  function checkScrollEmptySpace() {
    removeTableScrollEmptySpace({
      scrollElement: scrollRef?.current,
      tableElement: tableRef?.current,
    })
  }

  const { throttledHandler: handleCalculateButtonY } = useThrottleFunc(
    calculateCenterY,
    300
  )

  const { throttledHandler: handleCheckScrollEmptySpace } = useThrottleFunc(
    checkScrollEmptySpace,
    300
  )

  useResizeObserver({ callback: handleCalculateButtonY, ref: scrollRef })

  useResizeObserver({ callback: handleCheckScrollEmptySpace, ref: tableRef })

  useEffect(() => {
    if (scrollRef?.current) {
      calculateCenterY()
    }
  }, [])

  useEffect(() => {
    const elem = containerRef?.current ?? scrollRef?.current

    if (elem) {
      elem.addEventListener(EVENT_NAME_SCROLL, handleCalculateButtonY)

      return function cleanup() {
        elem.removeEventListener(EVENT_NAME_SCROLL, handleCalculateButtonY)
      }
    }
  }, [])

  function handleScrollLeft() {
    if (scrollRef?.current) {
      if (scrollRef.current.scrollLeft === 0) {
        return
      }

      if (
        scrollRef.current.scrollLeft < 0 ||
        scrollRef.current.scrollLeft - scrollPixelValue <= 0
      ) {
        scrollRef.current.scrollLeft = 0

        return
      }

      scrollRef.current.scrollLeft =
        scrollRef.current.scrollLeft - scrollPixelValue
    }
  }

  function handleScrollRight() {
    if (scrollRef?.current) {
      const maxScroll =
        scrollRef.current.scrollWidth - scrollRef.current.offsetWidth

      if (maxScroll <= scrollRef.current.scrollLeft + scrollPixelValue) {
        scrollRef.current.scrollLeft = maxScroll

        return
      }

      scrollRef.current.scrollLeft =
        scrollRef.current.scrollLeft + scrollPixelValue
    }
  }

  return { handleScrollLeft, handleScrollRight }
}
